import { Component, OnInit, OnDestroy } from '@angular/core';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'header-simplified',
    templateUrl: './headersimplified.component.html',
})
export class HeaderSimplifiedComponent implements OnInit, OnDestroy {
    
    constructor(private storageService: StorageService) {
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
    }

}